import handler from 'api/handler'

const prefix = '/admin/matrimonial'

const methods = {
    updateApprovalStatus: args => handler({ method: 'put', url: prefix + '/updateApprovalStatus', args }),
    fetchNewlyCreated: args => handler({ method: 'get', url: prefix + '/fetchNewlyCreated', args }),
    createByAdmin: args => handler({ method: 'post', url: prefix + '/create', args, isFormData: true }),
    verifyReference: args => handler({ method: 'post', url: prefix + '/verifyReference', args }),
    addReference: args => handler({ method: 'post', url: prefix + '/addReference', args }),
    fetchPendingReferenceVerifications: args => handler({ method: 'get', url: prefix + '/pendingReferenceVerifications', args })
}

export default methods
